/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-select.get-names.ts 
*/
:host {
  box-sizing: border-box;
  display: block;
  position: relative;
  width: 100%;
  z-index: 4;
}
:host * {
  box-sizing: border-box;
}

:host([open]:not([open=false])) {
  z-index: 5;
}

.ace-select {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  color: var(--ace-color-text-neutral--secondary);
  display: flex;
  flex-direction: column;
  min-width: var(--ace-select-min-width, 8.5rem);
  width: 100%;
}
.ace-select * {
  box-sizing: border-box;
}
.ace-select__label {
  font-size: var(--ace-type-font-size-text-x-small);
  letter-spacing: var(--ace-type-letter-spacing-text-x-small);
  line-height: var(--ace-type-line-height-text-x-small);
  font-family: var(--ace-type-font-family-text);
  font-weight: var(--ace-type-font-weight-button-subtle);
  transition: 100ms linear;
  color: var(--ace-color-text-neutral--primary);
  margin-bottom: var(--ace-primitive-spacing-x-tight);
}
.ace-select--placeholder {
  color: var(--ace-color-text-neutral--disabled);
}
.ace-select__wrapper {
  min-height: var(--ace-select-selection-height, var(--ace-semantic-form-fields-height));
  min-width: var(--ace-select-min-width, 8.5rem);
  overflow: visible;
  position: relative;
  width: 100%;
}
.ace-select__options {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  overflow-y: auto;
}
.ace-select__container {
  background-color: var(--ace-color-surface-solid--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--200);
  border-radius: var(--ace-semantic-foundation-radius-xs);
  min-height: var(--ace-semantic-form-fields-height);
  width: 100%;
  transition: 100ms linear;
}
.ace-select__container:hover {
  border-color: var(--ace-color-borders--300);
  cursor: pointer;
  transition: 100ms linear;
}
.ace-select__dropdown-toggle {
  transition-duration: 150ms;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.25, 0, 0.75, 1);
  margin-left: auto;
}
.ace-select__input, .ace-select__option {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  align-items: center;
  display: flex;
  gap: var(--ace-primitive-spacing-tight);
  overflow: hidden;
  user-select: none;
  transition: 100ms linear;
  font-family: var(--ace-type-font-family-input);
  font-size: var(--ace-semantic-form-fields-font-size);
  font-weight: var(--ace-type-font-weight-text);
  letter-spacing: var(--ace-type-letter-spacing-text-regular);
  line-height: var(--ace-semantic-form-fields-line-height);
}
.ace-select__input span, .ace-select__option span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ace-select__input {
  color: var(--ace-color-text-neutral--secondary);
  padding: var(--ace-semantic-form-fields-select-vertical-padding) var(--ace-semantic-form-fields-padding-horizontal);
}
.ace-select__input--selected {
  color: var(--ace-color-text-neutral--primary);
}
.ace-select__input--with-template {
  padding: 0;
  position: relative;
}
.ace-select__input--with-template .ace-select__dropdown-toggle {
  position: absolute;
  display: inline-block;
  vertical-align: middle;
  right: var(--ace-semantic-form-fields-padding-horizontal);
}
.ace-select__option {
  color: var(--ace-color-text-neutral--interactive);
  display: none;
  min-height: var(--ace-semantic-form-fields-height);
  padding: var(--ace-semantic-form-fields-select-vertical-padding) calc(2 * var(--ace-semantic-form-fields-padding-horizontal) + var(--ace-primitive-spacing-x-tight)) var(--ace-semantic-form-fields-select-vertical-padding) var(--ace-semantic-form-fields-padding-horizontal);
  transition: 100ms linear;
}
.ace-select__option:hover {
  background-color: var(--ace-color-surface-solid--200);
  transition: 100ms linear;
}
.ace-select__option--selected {
  background-color: var(--ace-color-brand-primary--100);
  color: var(--ace-color-text-neutral--interactive-uni-light) !important;
}
.ace-select__option--selected:hover {
  background-color: var(--ace-color-brand-primary--200);
  transition: 100ms linear;
}
.ace-select__option--with-template {
  padding: 0;
}
.ace-select--up .ace-select__container {
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.ace-select--up .ace-select__input {
  order: 2;
}
.ace-select--up .ace-select__option {
  order: 1;
}
.ace-select:focus-visible, .ace-select:focus {
  outline: none;
}
.ace-select:focus-visible .ace-select__wrapper, .ace-select:focus .ace-select__wrapper {
  position: relative;
  z-index: 0;
  /* Create a pseudo-element outline that is stacked behind the container list */
}
.ace-select:focus-visible .ace-select__wrapper::before, .ace-select:focus .ace-select__wrapper::before {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
  border-radius: var(--ace-semantic-foundation-radius-xs);
  content: "";
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  z-index: -1;
}
.ace-select--disabled .ace-select__container {
  background-color: var(--ace-color-surface-solid--200);
  border-color: var(--ace-color-surface-solid--200);
  transition: 100ms linear;
}
.ace-select--disabled .ace-select__container:hover {
  border-color: var(--ace-color-surface-solid--200);
  cursor: default;
  transition: 100ms linear;
}
.ace-select--disabled .ace-select__input {
  color: var(--ace-color-text-neutral--disabled);
}
.ace-select--error .ace-select__container,
.ace-select--error .ace-select__container:hover {
  border-color: var(--ace-color-surface-semantic--error);
}
.ace-select--is-open .ace-select {
  box-shadow: var(--ace-elevation-level-1);
}
.ace-select--is-open .ace-select__container {
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.02)) drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.04));
  height: unset;
  position: absolute;
  z-index: 5;
}
.ace-select--is-open .ace-select__dropdown-toggle {
  transform: rotate(-180deg);
}
.ace-select--is-open .ace-select__option {
  display: flex;
}